import { atom } from 'jotai';

import { type FocusPosition } from '~/shared/components/FieldFocusIndicator';

export const $focusedField = atom<string | null>(null);

export const $remoteFocusPositions = atom<FocusPosition[]>([]);
